<template>
    <div class="login-form">
        <el-form 
            class="fill-form"
            ref="login" 
            :model="form" 
            :rules="rules"
            label-width="auto"
        >   
            <el-form-item 
                class="flex-colulmn"  
                prop="email"
            >
                <label for="">Email</label>
                <el-input 
                    v-model="form.email"
                ></el-input>
            </el-form-item>  

            <el-form-item 
                class="flex-colulmn"  
                prop="password"
            >
                <label for="">Password</label>
                <el-input 
                    type="password"
                    v-model="form.password"
                ></el-input>
            </el-form-item>  

            <el-form-item class="el-form-item__cta">
                <el-button 
                    class="default-btn" 
                    @click="loginAction" 
                >
                    Login
                </el-button>
                <el-button>Cancel</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
import {mapActions, mapMutations, mapGetters} from 'vuex';

export default {
    name: 'login-form', 
    computed: {
        ...mapGetters({
            form: 'auth/form',
            rules: 'auth/rules'
        })
    }, 
    methods: {
         ...mapMutations({
            loginUser: 'auth/loginUser'
        }),
        ...mapActions({
            login: 'auth/login'
        }),
        async loginAction() {
            const valid = await this.$refs['login'].validate();
            
            if(!valid) {
                return;
            }
        
            const response = await this.login(); 
            
            if(response.status != 200) {
                this.$notify({
                    title: "Try again", 
                    message: "Authentication failed. Wrong email or password"
                })
                
                return;
            }
            
            this.loginUser(true); 
            this.$router.push({name: 'Home'}, () => {}); 
        }
    } 
}
</script>

<style lang="scss">
// @import '@/assets/scss/main.scss';

.login-form {
    display: flex;
    flex-direction: column;
    width: 400px;
    box-shadow: rgba(0, 0, 0, 0.1) 0px 0px 10px;
    box-sizing: border-box;
    color: rgb(94, 108, 132);
    margin: 0px auto 24px;
    padding: 32px 40px;
    background: rgb(255, 255, 255);
    border-radius: 3px; 
}

.default-btn {
    &_disabled {
        background-color: grey !important;
    }
}

.flex-colulmn {
    display: flex;
    flex-direction: column;
}
</style>

<style>
.flex .el-form-item__content {
    display: flex;
}
</style>